"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var LinkButton_1 = __importDefault(require("../../Button/LinkButton"));
var fields_1 = require("../fields");
var StyledResult = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #ffffff;\n  padding: 1em;\n  border: 1px solid #e5ebf0;\n  display: grid;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  background-color: #ffffff;\n  padding: 1em;\n  border: 1px solid #e5ebf0;\n  display: grid;\n  align-items: center;\n  justify-content: space-between;\n"])));
var styles = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 2em;\n  background: #e5ebf0;\n"], ["\n  padding: 2em;\n  background: #e5ebf0;\n"])));
var SText = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 1em;\n"], ["\n  margin-bottom: 1em;\n"])));
var StyledResultDetails = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 13px;\n"], ["\n  font-size: 13px;\n"])));
var OsobaResult = react_1.default.forwardRef(function (_a, ref) {
    var className = _a.className, osobyResults = _a.osobyResults, onClick = _a.onClick;
    return (react_1.default.createElement("div", { ref: ref, className: className },
        react_1.default.createElement(SText, null,
            react_1.default.createElement("strong", null, "Zadan\u00FDm parametr\u016Fm pro ztoto\u017En\u011Bn\u00ED odpov\u00EDd\u00E1 v\u00EDce v\u00FDsledk\u016F."),
            react_1.default.createElement("br", null),
            "Zvolte jeden z nich, nebo zadejte dal\u0161\u00ED parametry pro ztoto\u017En\u011Bn\u00ED."),
        osobyResults.map(function (osoba) {
            var _a;
            return (react_1.default.createElement(StyledResult, { key: osoba.jmeno },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("strong", null,
                        osoba.titul,
                        " ",
                        osoba.jmeno,
                        " ",
                        osoba.prijmeni,
                        " ",
                        osoba.titulZa),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(StyledResultDetails, null,
                        "I\u010CO:\u00A0",
                        osoba.ico,
                        "\u00A0\u00A0\u00A0\u00A0Datov\u00E1 schr\u00E1nka:\u00A0", (_a = osoba.datoveSchranky) === null || _a === void 0 ? void 0 :
                        _a[0].hodnota,
                        "\u00A0\u00A0\u00A0\u00A0",
                        osoba.adresaPobytu != null ? fields_1.getAddressLabel(osoba.adresaPobytu) : '')),
                react_1.default.createElement(LinkButton_1.default, { type: "button", className: "button", onClick: function () { return onClick(osoba); } }, "vybrat")));
        })));
});
OsobaResult.defaultProps = {
    className: undefined,
};
exports.default = styled_components_1.default(OsobaResult)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
